import { useEffect } from 'react'
import { show_welcome_page } from '@/services/Constants'
import { persistent } from '@/services/LocalStorage'
import { OnboardingForm } from './internal/OnboardingForm'

function WelcomeToMusePage() {
    useEffect(() => {
        persistent.set(show_welcome_page, false)
    }, [])

    return (
        <div style={{ height: '100vh', overflow: 'auto' }}>
            <OnboardingForm />
        </div>
    )
}

export default WelcomeToMusePage
